"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReloadButton = exports.RedoIcon = exports.DeleteButton = exports.FileUploadButton = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importStar(require("react"));
var icons_1 = require("../../../../icons");
var styles_1 = require("../../../../styles");
var ErrorMessage_1 = require("../../ErrorMessage");
var Button = styled_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  padding: 7px 16px;\n  font-size: 16px;\n  line-height: 1.5;\n  color: ", ";\n  background: #f0f0f0;\n  border: 1px solid ", ";\n  border-radius: 4px;\n  min-height: 40px;\n  min-width: 96px;\n  text-align: center;\n"], ["\n  ", "\n  padding: 7px 16px;\n  font-size: 16px;\n  line-height: 1.5;\n  color: ", ";\n  background: #f0f0f0;\n  border: 1px solid ", ";\n  border-radius: 4px;\n  min-height: 40px;\n  min-width: 96px;\n  text-align: center;\n"])), styles_1.MixinButtonStyle, styles_1.COLOR.font.base, styles_1.COLOR.border.base);
var SkeltonInput = styled_1.default.input(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  visibility: hidden;\n  opacity: 0;\n  position: absolute;\n  width: 0;\n  height: 0;\n"], ["\n  visibility: hidden;\n  opacity: 0;\n  position: absolute;\n  width: 0;\n  height: 0;\n"])));
var FileUploadButton = function (_a) {
    var disabled = _a.disabled, label = _a.label, onFileSelect = _a.onFileSelect, propertyId = _a.propertyId, _b = _a.error, error = _b === void 0 ? false : _b, accept = _a.accept;
    var inputFile = react_1.useRef(null);
    var handleFileSelect = function (e) {
        var _a;
        var file = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (!file) {
            return;
        }
        onFileSelect(file);
    };
    var handleButtonClick = function () {
        var _a;
        if (inputFile) {
            (_a = inputFile.current) === null || _a === void 0 ? void 0 : _a.click();
        }
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(SkeltonInput, { ref: inputFile, type: "file", accept: accept.join(','), disabled: disabled, onChange: handleFileSelect, "aria-errormessage": ErrorMessage_1.getFieldErrorMessageId(propertyId), "aria-invalid": error }),
        react_1.default.createElement(Button, { type: "button", disabled: disabled, onClick: handleButtonClick }, label)));
};
exports.FileUploadButton = FileUploadButton;
var DeleteButton = function (_a) {
    var disabled = _a.disabled, onClick = _a.onClick;
    return (react_1.default.createElement(Button, { type: "button", disabled: disabled, onClick: onClick }, "\u524A\u9664\u3059\u308B"));
};
exports.DeleteButton = DeleteButton;
var Icon = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 14px;\n  line-height: 1;\n  transform: translateY(1px);\n  margin: auto;\n  svg {\n    fill: ", ";\n    width: 14px;\n    height: 14px;\n  }\n"], ["\n  width: 14px;\n  line-height: 1;\n  transform: translateY(1px);\n  margin: auto;\n  svg {\n    fill: ", ";\n    width: 14px;\n    height: 14px;\n  }\n"])), styles_1.COLOR.font.base);
var RedoIcon = function () { return (react_1.default.createElement(Icon, { dangerouslySetInnerHTML: { __html: icons_1.REDO_ICON } })); };
exports.RedoIcon = RedoIcon;
var ReloadButton = function (_a) {
    var disabled = _a.disabled, onClick = _a.onClick;
    return (react_1.default.createElement(Button, { type: "button", disabled: disabled, onClick: onClick },
        react_1.default.createElement(exports.RedoIcon, null)));
};
exports.ReloadButton = ReloadButton;
var templateObject_1, templateObject_2, templateObject_3;
